import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Check, AlertTriangle } from 'lucide-react';
import { Countdown } from './Countdown';
export function PricingSection() {
  return <section id="pricing" className="py-14 bg-petroleum relative overflow-hidden" data-id="element-246">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-electric to-transparent opacity-50" data-id="element-247"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-248">
        {/* Scarcity Header */}
        <div className="max-w-3xl mx-auto text-center mb-10" data-id="element-249">
          <div className="inline-flex items-center gap-2 bg-red-500/10 text-red-400 border border-red-500/20 px-4 py-2 rounded-full text-sm font-bold mb-5" data-id="element-250">
            <AlertTriangle className="w-4 h-4" data-id="element-251" />
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>

          <div className="mb-5" data-id="element-252">
            <Countdown data-id="element-253" />
          </div>

          <p className="text-textsecondary mb-2" data-id="element-254">
            ⚠️ Después sube $10.000 ARS. No vuelve.
          </p>
          <p className="text-energy font-medium flex items-center justify-center gap-2" data-id="element-255">
            <span className="w-2 h-2 rounded-full bg-energy animate-pulse" data-id="element-256"></span>
            72% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>

        <div className="text-center mb-8" data-id="element-257">
          <h2 className="text-4xl font-extrabold" data-id="element-258">ELEGÍ TU MANUAL</h2>
        </div>

        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 items-center" data-id="element-259">
          {/* Basic Plan */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-graphite border border-white/10 rounded-3xl p-8 hover:border-electric/30 transition-all" data-id="element-260">
            <h3 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-261">
              MANUAL CERO RIESGO
            </h3>
            <p className="text-textsecondary mb-6" data-id="element-262">6 Tomos + 6 Bonos</p>

            <div className="bg-petroleum rounded-xl p-4 mb-8" data-id="element-263">
              <p className="text-sm text-textsecondary mb-1" data-id="element-264">Ideal para:</p>
              <p className="font-medium" data-id="element-265">Autonomía total en tu hogar</p>
            </div>

            <div className="mb-8" data-id="element-266">
              <span className="text-textsecondary line-through text-xl" data-id="element-267">
                $89.000
              </span>
              <div className="flex items-baseline gap-2" data-id="element-268">
                <span className="text-4xl font-extrabold text-white" data-id="element-269">
                  $19.990
                </span>
                <span className="text-textsecondary font-medium" data-id="element-270">ARS</span>
              </div>
            </div>

            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNBtdqfmZw6mycXp8XOqb90/es-ar?_r=AQABgnNpXVO1rI1txCBQNxGb_YcTrUPiJJDRD8WaZPPvwao&cart_link_id=NRLX8ejE&preview_theme_id=154123698339" target="_blank" rel="noopener noreferrer" className="w-full bg-petroleum hover:bg-petroleum/80 border border-electric/50 text-white font-bold py-4 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-271">
              QUIERO MI MANUAL
            </a>
          </motion.div>

          {/* Pro Plan */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-[#1a2642] to-petroleum border-2 border-electric rounded-3xl p-8 relative transform md:-translate-y-4 glow-electric" data-id="element-272">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-graphite font-bold px-4 py-1 rounded-full text-sm flex items-center gap-1" data-id="element-273">
              <Zap className="w-4 h-4 fill-graphite" data-id="element-274" /> MÁS POPULAR
            </div>

            <h3 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-275">
              MANUAL + EMPRENDEDOR
            </h3>
            <p className="text-textsecondary mb-6" data-id="element-276">
              6 Tomos + 6 Bonos + Manual del Electricista Emprendedor
            </p>

            <div className="bg-graphite/50 rounded-xl p-4 mb-8 border border-gold/20" data-id="element-277">
              <p className="text-sm text-gold mb-1" data-id="element-278">Ideal para:</p>
              <p className="font-medium" data-id="element-279">
                Los que quieren monetizar el conocimiento
              </p>
            </div>

            <div className="mb-8" data-id="element-280">
              <span className="text-textsecondary line-through text-xl" data-id="element-281">
                $119.000
              </span>
              <div className="flex items-baseline gap-2" data-id="element-282">
                <span className="text-5xl font-extrabold text-white" data-id="element-283">
                  $27.990
                </span>
                <span className="text-textsecondary font-medium" data-id="element-284">ARS</span>
              </div>
            </div>

            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNBte3hZ4VnB2gzUPhbZCeA/es-ar?_r=AQABnYG6CXEPZmPUzlBa5y9-PjHk-TUFy23-FX4xkKx4UqY&cart_link_id=5Kg6Mib6&preview_theme_id=154123698339" target="_blank" rel="noopener noreferrer" className="w-full bg-gold hover:bg-yellow-400 text-graphite font-bold py-5 rounded-xl transition-all transform hover:-translate-y-1 glow-gold flex gap-2 text-lg items-center justify-center text-center" data-id="element-285">
              QUIERO EL MANUAL + EMPRENDEDOR
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}